import mongoose from 'mongoose';
import modelTagSchema, { ITagDocument } from '../schemas/tag-as-model';

export default (mongoose.models.Tag ||
  mongoose.model<ITagDocument>('Tag', modelTagSchema)) as mongoose.Model<ITagDocument>;
